import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link, useLocation } from 'react-router-dom';

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

export default function About() {
    const textRef = useRef(null);
    const location = useLocation(); // Get current location

    useEffect(() => {
        // Apply animation only for desktop view
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop) {
            gsap.fromTo(
                textRef.current,
                { x: '-30%', opacity: 0 }, // Start position off-screen
                {
                    x: '0%', // End position in place
                    opacity: 1,
                    duration: 2.5,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: textRef.current,
                        start: 'top 80%', // Animation starts when the text enters the viewport
                        end: 'top 30%', // Ends after reaching the target position
                        scrub: 1.5, // Smooth scrolling-based animation
                    },
                }
            );
        }

        // Cleanup ScrollTrigger on unmount
        return () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, []);

    return (
        <div className="bg-gray-100 md:py-20 py-10">
            <div className="container mx-auto">
                <div className="relative flex md:px-10 px-5 flex-col-reverse lg:flex-row items-center lg:items-start lg:justify-between">
                    {/* Text Section */}
                    <div
                        ref={textRef}
                        className="md:absolute md:bottom-14 md:right-36 bg-indigo-900 text-white flex justify-start md:gap-3 flex-col items-start p-6 lg:ml-10 lg:mt-0 md:mt-6 shadow-lg lg:w-2/5"
                    >
                        <h2 className="text-2xl font-semibold md:mb-6 mb-3">About us</h2>
                        <p className="mb-4 text-start">
                            Northern Professional continues its successful journey after many years, evolving from a project-based company in the UAE market to a comprehensive provider of horeca trading activities. From the initial stages of each project to a seamless transfer of outcomes for our customers, we prioritize risk-free execution.
                        </p>
                        <p className="mb-4 text-start">
                            Our collaboration with world-renowned catering suppliers enhances our offerings, while our dedicated team ensures excellent after-sales service, which remains our primary concern.
                        </p>
                        {/* Conditionally render the Link based on the pathname */}
                        {location.pathname !== '/about' && (
                            <Link to={'/about'} className="bg-white text-blue-600 px-4 py-2 mt-3 font-semibold hover:bg-gray-200">
                                More About Us
                            </Link>
                        )}
                    </div>

                    {/* Image Section */}
                    <div className="lg:w-2/3 md:h-[500px]">
                        <img
                            src="/assets/about.jpg"
                            alt="Restaurant Interior"
                            className="w-full h-full object-cover shadow-lg"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}